import OrderApi from "@/api/zfb/order"
import { GetItemType } from '@/utils/constant/item'
import {localStatusList,DyOrders_LocalStatus_WaitBuy,DyOrders_LocalStatus_WaitSend,DyOrders_LocalStatus_SendOk,DyOrders_LocalStatus_Received,DyOrders_LocalStatus_Refund_Success,DyOrders_LocalStatus_Cancel} from '@/utils/constant/order_before'
import { After_Sale_List, Seller_Wait_Deal, Wait_Returning, Buyer_Wait_Deal, Wait_Buyer_Post, Buyer_Already_Post, Platform_Dealing ,Refund_Success, Refund_Close, Refund_Fail } from '@/utils/constant/order_after'

// 获取拍单列表
async function GetOrderList(isMallGroupType, currentPage, pageSize, formState) {
  const params = getParams(currentPage, pageSize, formState)
  // 店群模式时才需要传relationId
  const { errMsg, itemList, total } = await OrderApi.GetOrders(isMallGroupType ? params.relationId : '', params)
  const newShotOrderList = updataShotOrderList(itemList)
  return { total, errMsg, shotOrderList: newShotOrderList }
}

// 整理订单列表需要的参数
function getParams(page, size, { OrderId, purchasedOrderId, orderInfoStartTime, orderInfoEndTime, relationId, goodsName }) {
  const data = {
    page,
		size,
		order_by: '-CreateTime',
		hasPreparePurchaseInfo: 1, // 是否已关联过订单
    orderSnStr: OrderId ? OrderId.trim() : '', // 支付宝订单号
    relationId // 店铺关联ID
	}
  if (purchasedOrderId) data['PurchasedOrderInfo.OrderId'] = purchasedOrderId.trim() // 关联订单号
  if (orderInfoStartTime) data['PurchasedOrderInfo.CreateStartTime'] = orderInfoStartTime.trim() // 拍单开始时间
  if (orderInfoEndTime) data['PurchasedOrderInfo.CreateEndTime'] = orderInfoEndTime.trim() // 拍单结束时间
  if (goodsName) data['ItemInfos.GoodsName'] = goodsName.trim() // 商品标题
  return data
}

// 整理接口返回的拍单列表数据
function updataShotOrderList(shotOrderList) {
  const newShotOrderList = []
  if (!shotOrderList) return newShotOrderList
  shotOrderList.forEach(item =>{
    try {
      var newItem = {
        mallName: item.MallInfo.Name,
        mallId: item.MallInfo.Id,
        orderId: item.OrderInfo.OrderId,
        goodsId: item.ItemInfos[0].GoodsIdStr || item.ItemInfos[0].GoodsId,
        goodsCount: item.ItemInfos[0].GoodsCount,
        goodsTitle: item.ItemInfos[0].GoodsName,
        goodsImg: item.ItemInfos[0].GoodsImg || 'https://gimg3.baidu.com/search/src=https%3A%2F%2Fzhengxin-pub.cdn.bcebos.com%2Flogopic%2Fa9936a369e82e0c6c42112674a5220e8_fullsize.jpg&refer=http%3A%2F%2Fwww.baidu.com&app=2021&size=w256&n=0&g=0n&q=100&fmt=auto?sec=1706374800&t=ff6dfb524dc82cec4afda858ecd534fe',
        goodsTotalPrice: item.ItemInfos[0].TotalPrice ? (item.ItemInfos[0].TotalPrice / 100).toFixed(2) : '--',
        // payAmount: item.OrderInfo.PayAmount ? (item.OrderInfo.PayAmount / 100).toFixed(2) : '--' ,
        payAmount: item.OrderInfo.PayPrice ? (item.OrderInfo.PayPrice / 100).toFixed(2) : '--' ,
        cost: getCost(item.PurchasedOrderInfo) || '--',
        profit: getProfit(item) || '--',
        platformCostAmount: (item.OrderInfo.PlatformCostAmount ? (item.OrderInfo.PlatformCostAmount / 100).toFixed(2) : 0), // 平台补贴
        purchasedOrderId: item.PurchasedOrderInfo.OrderId,
        purchasedAccount: item.PurchasedOrderInfo.BuyerInfo.Name,
        purchasedTime: item.PurchasedOrderInfo.CreateTime, // 拍单时间
        orderCreateTime: item.OrderInfo.CreateTime, // 下单时间
        purchasedPlatFormType: item.PurchasedOrderInfo.PlatFormType, // 采购号平台
        itemType: GetItemType(item.PurchasedOrderInfo.PlatFormType),
        orderStatus: GetCurrentLocalStatus(item)?.name,
        afterStatus: GetCurrentAfterStatus(item)?.name === '全部' ? '无售后' : GetCurrentAfterStatus(item)?.name
      }
    } 
    catch (error) {
      console.log(error)
    }
    newShotOrderList.push(newItem)
  })
  return newShotOrderList
}

// 利润 = 实付-成本+平台补贴+用户自定义更正利润 (如有)
function getProfit(item) {
  const cost = getCost(item.PurchasedOrderInfo) || 0
  // const payAmount = (item.OrderInfo.PayAmount || 0) + (item.OrderInfo.PlatformCostAmount || 0)
  const payAmount = (item.OrderInfo.PayPrice || 0) + (item.OrderInfo.PlatformCostAmount || 0)
  return ((payAmount - cost * 100) / 100).toFixed(2)
}

// 拍单金额
function getCost(PurchasedOrderInfo) {
  return PurchasedOrderInfo.PayPrice?.toFixed(2) || ''
}

// 获取订单状态 (本地)
function GetCurrentLocalStatus(orderInfo) {
  const currentLocalStatus = localStatusList.find(item => {
    if (DyOrders_LocalStatus_WaitBuy.value == item.value) item.color = '#108ee9'
    else if (DyOrders_LocalStatus_WaitSend.value == item.value) item.color = 'skyblue'
    else if (DyOrders_LocalStatus_SendOk.value == item.value) item.color = 'yellow'
    else if (DyOrders_LocalStatus_Received.value == item.value) item.color = 'green'
    else if (DyOrders_LocalStatus_Refund_Success.value == item.value) item.color = 'red'
    else if (DyOrders_LocalStatus_Cancel.value == item.value) item.color = 'pink'
    return item.value == orderInfo.LocalInfo.OrderStatus
  })
  return currentLocalStatus || {}
}

// 获取售后状态
function GetCurrentAfterStatus(orderInfo) {
  const currentLocalStatus = After_Sale_List.find(item => {
    if (Seller_Wait_Deal.value == item.value) item.color = 'red'
    else if (Wait_Returning.value == item.value) item.color = 'yellow'
    else if (Buyer_Wait_Deal.value == item.value) item.color = 'blue'
    else if (Wait_Buyer_Post.value == item.value) item.color = 'skyblue'
    else if (Platform_Dealing.value == item.value) item.color = 'red'
    else if (Refund_Fail.value == item.value) item.color = 'red'
    else if (Refund_Success.value == item.value) item.color = 'blue'
    else if (Refund_Close.value == item.value) item.color = 'purple'
    else if (Buyer_Already_Post.value == item.value) item.color = 'pink'
    return item.value == orderInfo.LocalInfo.AfterSalesStatus
  })
  return currentLocalStatus || {}
}

// 根据拍单时间段获取对应的全部订单数据
async function GetAllOrderList(isMallGroupType, formState) {
  let list = []
  const size = 10 // 每页最大数量
  const { total, shotOrderList } = await GetOrderList(isMallGroupType, 1, size, formState)
  const maxPage = Math.ceil(total / size)
  list = [...list, ...shotOrderList]
  // 如果大于1页, 则循环去获取拍单数据, 累加起来
  if (maxPage > 1) {
    for (let i = 2; i <= maxPage; i++) {
      const { shotOrderList } = await GetOrderList(isMallGroupType, i, size, formState)
      if (!shotOrderList?.length) break
      list = [...list, ...shotOrderList]
    }
  }
  return { list }
}

export default { GetOrderList, GetAllOrderList }